import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import Icon from "./_internal/Icon";
var DisplayOutlined = /*#__PURE__*/React.forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/React.createElement("svg", _extends({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("path", {
    d: "M512 149.333c119.808 0 233.621 49.11 319.168 117.184l11.008 8.96C927.019 346.667 981.333 436.245 981.333 512c0 75.776-54.314 165.333-139.157 236.501l-11.008 8.982C745.621 825.536 631.808 874.667 512 874.667s-233.621-49.11-319.168-117.184l-11.008-8.96C96.981 677.333 42.667 587.755 42.667 512c0-75.776 54.314-165.333 139.157-236.501l11.008-8.982C278.379 198.464 392.192 149.333 512 149.333zm0 85.334c-89.387 0-181.995 34.41-257.45 91.904l-7.745 6.037-10.133 8.277C168.256 398.272 128 466.112 128 512c0 44.416 37.696 109.397 101.355 164.907l6.464 5.504 10.133 8.32C323.627 752.469 419.52 789.333 512 789.333c89.387 0 181.995-34.41 257.45-91.904l7.745-6.037 10.133-8.277C855.744 625.728 896 557.888 896 512c0-44.416-37.696-109.397-101.355-164.907l-6.464-5.504-10.133-8.32C700.373 271.531 604.48 234.667 512 234.667zm0 106.666a170.667 170.667 0 110 341.334 170.667 170.667 0 010-341.334zm0 85.334a85.333 85.333 0 100 170.666 85.333 85.333 0 000-170.666z"
  }));
  return /*#__PURE__*/React.createElement(Icon, _extends({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
DisplayOutlined.displayName = "DisplayOutlined";
export default DisplayOutlined;